import { down } from 'styled-breakpoints'
import styled from 'styled-components'

export const Container = styled.div<{ isFlightTab?: boolean; isHotelTab?: boolean }>`
  position: relative;
  width: 100%;
  margin: 40px 0px;
  ${(props) =>
    (props.isFlightTab || props.isHotelTab) &&
    `
    min-height: 500px;
  `}

  ${down('md')} {
    width: 100%;
    margin-bottom: 32px;
    ${(props) =>
      (props.isFlightTab || props.isHotelTab) &&
      `
      min-height: 450px;
    `}
  }
`

export const HeaderContainer = styled.div`
  align-items: baseline;
  gap: 12px;
  display: flex;
  margin: 0px;
  flex-direction: column;

  ${down('md')} {
    gap: 18px;
    position: relative;
    width: 100%;
  }
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.h2`
  color: #131717;
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  margin-bottom: 0px;
  margin-top: 32px;
  ${down('md')} {
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    margin-bottom: 0px;
    margin-top: 24px;
  }
`

export const Subtitle = styled.p`
  color: #131717;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 0px;
  ${down('md')} {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 0px;
  }
`

export const TabsContainer = styled.div`
  display: flex;
  gap: 12px;
  position: relative;
  flex-wrap: nowrap;
  margin-top: 16px;

  ${down('md')} {
    display: flex;
    flex-direction: row;
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    flex-wrap: nowrap !important;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 20px 0 5px 0;
    margin: -20px 0 -5px 0;
    gap: 8px;
    align-items: center;

    &::-webkit-scrollbar {
      display: none;
    }

    [dir='rtl'] & {
      padding-right: 0px;
    }
  }
`

export const TabsButton = styled.div<{ active: boolean }>`
  border: ${(props) => (props.active ? '1px solid #131717;' : 'none')};
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: transparent;
  border-radius: 200px;
  cursor: pointer;
  color: #131717;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  z-index: 1;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  line-height: normal;
  white-space: nowrap;

  ${down('md')} {
    display: inline-flex;
    height: 39px;
    flex-shrink: 0;
    white-space: nowrap;
    min-width: fit-content;
    width: auto;
  }
`

export const CardsWrapper = styled.div<{ isFlightTab?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  position: relative;

  ${down('md')} {
    margin-bottom: 16px;
    .splide__track {
      overflow: hidden;
    }
  }
`

export const CardContainer = styled.div`
  cursor: pointer;
`
